import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { fetchBrandsGroup, splitBrandId } from '@common/Filters/helpers';
import { parseFavoriteBrands } from '@common/Filters/services/fetchBrandGroups';

export function useBrandsGroup(isEnabled = true) {
    const [brandGroupsData, setBrandGroupsData] = useState([]);

    const { gender, listingBrandgroups } = useSelector(({ listing }) => listing);
    const { availableFilters } = useSelector(({ filters }) => filters);
    const { brand: availableBrandFilters } = availableFilters;
    const { activeFilters } = useSelector(({ filters }) => filters);
    const activeBrandFilters = useMemo(() => activeFilters.filter(item => item.filterType === 'brand'), [activeFilters]);
    const activeBrandIds = useMemo(() => activeBrandFilters.map(splitBrandId), [activeBrandFilters]);

    const brandGroupId = listingBrandgroups[gender];

    useEffect(() => {
        const fetchBrandGroups = async () => {
            const newBrandGroups = await fetchBrandsGroup(brandGroupId);
            const favoriteBrands = await parseFavoriteBrands(availableBrandFilters, gender);
            setBrandGroupsData([...newBrandGroups, ...favoriteBrands]);
        };

        if (isEnabled) {
            fetchBrandGroups();
        }
    }, [availableBrandFilters, brandGroupId, gender, isEnabled]);

    return { brandGroupsData, activeBrandIds };
}
